import { cx } from '@platform/core/lib/cx';
import type { IAvatarProps } from './IAvatarProps';
import './avatar.css';

/** Розмір ініціалів за розміром кола: 11px до 30px, 12px до 40px, далі третина сторони (мінімум 11px — foundations/typography). */
const fontSizeOf = (size: number): number => (size <= 30 ? 11 : size <= 40 ? 12 : Math.round(size / 3));

/** Аватар: ініціали в колі (тон `accent` — --accent-soft з акцентним текстом 700, `neutral` — як у таблицях прототипу v4); без користувача — «?». */
export function Avatar({ user, size = 26, tone = 'accent' }: IAvatarProps) {
  const style = { width: size, height: size, fontSize: fontSizeOf(size) };
  const className = cx('avatar', tone === 'neutral' && 'avatar--neutral');
  if (!user) return <span className={className} style={style} aria-hidden>?</span>;
  return <span className={className} title={user.name} style={style}>{user.initials}</span>;
}
